const upcomingForm = () => {
  const tabs = [...document.querySelectorAll(".js-upcoming-form-tab")];
  const boxes = [...document.querySelectorAll(".js-upcoming-form-box")];

  if (tabs.length === 0) return;

  boxes[0].classList.add("show");
  tabs[0].classList.add("active");

  tabs.forEach((tab, index) => {
    tab.addEventListener("click", () => {
      tabs.forEach((t) => {
        t.classList.remove("active");
      });
      tab.classList.add("active");
      boxes.forEach((t) => {
        t.classList.remove("show");
      });
      boxes[index].classList.add("show");
    });
  });
};

export default upcomingForm;
